export default {
  frontRoutes: [
    {
      path: '/oto',
      name: 'Oto',
      component: () => import(/* webpackChunkName: "oto" */ '../views/oto/Oto.vue'),
    },
    {
      path: '/oto/coupon',
      name: 'OtoCoupon',
      component: () => import(/* webpackChunkName: "oto" */ '../views/oto/OtoCoupon.vue'),
    },
    {
      path: '/oto/:id',
      name: 'OtoTeacherShow',
      component: () =>
        import(
          /* webpackChunkName: "oto" */
          '../views/oto/OtoTeacherShow.vue'
        ),
    },
  ],
  memberRoutes: [
    {
      path: '/member/oto',
      name: 'MemberOto',
      component: () =>
        import(
          /* webpackChunkName: "member" */
          '../views/oto/MemberOto.vue'
        ),
      meta: {
        requireAuth: true,
        title: '我的约课',
        root: true,
      },
    },
    {
      path: '/member/oto/communication',
      name: 'MemberOtoCommunication',
      component: () =>
        import(
          /* webpackChunkName: "member" */
          '../views/oto/MemberOtoCommunication.vue'
        ),
      meta: {
        requireAuth: true,
        title: '沟通记录',
      },
    },
  ],
};
